<template>
    <date-picker :name="dpname" v-model="dpdate" :config="options" @dp-change="changeValue"></date-picker>
</template>

<script>
//import 'bootstrap/dist/css/bootstrap.css';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
  name: "mmf-datepicker",
  components: {
      datePicker
  },
  props: {
      "name": {
          type: String
      },
      "date": {
          type: Object,
          default: function() {
              return null
          }
      },
      'value': {
          type: String
      }
  },
  data: function() {
    return {
        dpdateFormatted: "",
        dpname: this.name,
        dpdate: this.date,
        options: {
            // https://momentjs.com/docs/#/displaying/
            format: this.$t("month.format.viewMode"),
            useCurrent: false,
            showClear: true,
            showClose: true,
            icons: {
                time: 'fa fa-clock',
                date: 'fa fa-calendar',
                up: 'fa fa-arrow-up',
                down: 'fa fa-arrow-down',
                previous: 'fa fa-chevron-left',
                next: 'fa fa-chevron-right',
                today: 'fa fa-calendar-check',
                clear: 'fa fa-trash-alt',
                close: 'fa fa-times-circle'
            }
        }
    }
  },
  methods: {
      changeValue: function ($event) {
          var moment = $event.date
          if (moment) {
              this.dpdate = moment.toDate()
              let str = moment.format(this.$t("month.format.sendMode"));
              let arr=str.split(/-/);
              this.dpdateFormatted = arr[0]+'-'+arr[1]+'-01'
          }
          else {
              this.dpdate = null
              this.dpdateFormatted = "";
          }
          this.$emit('input', this.dpdateFormatted);
      }
  },
  mounted(){
    if(this.value!=""){
            var str = this.value;
            this.dpdate=new Date(str)
            }
  },
  watch: {
      value:function(val){
          if(val == ""){
              this.dpdate=null;
              this.dpdateFormatted = "";
          }
      }
  },
}
</script>